import "./Contact.css";

function Contact() {
  return (
    <section className="contact-page">

      {/* Banner */}
      <div className="contact-banner">
        <div className="contact-banner-overlay">
          <h1>Contact Us</h1>
          <p>We’re here to help you find your dream property</p>
        </div>
      </div>

      {/* Content */}
      <div className="contact-content">

        {/* Left Info */}
        <div className="contact-info">

          <h2>Get In Touch</h2>
          <p>
            Have questions regarding property investment or buying?
            Our experts are always ready to help you.
          </p>

          <div className="info-item">
            <h4>📍 Address</h4>
            <span>Zirakpur  Punjab , 140604</span>
          </div>


          <div className="info-item">
            <h4>📧 Email</h4>
            <span>info@urbanbrick.in.net</span>
          </div>

        </div>

        {/* Right Form */}
        <div className="contact-form">

          <h3>Send Message</h3>

          <form>
            <div className="form-row">
              <input type="text" placeholder="Full Name" />
              <input type="email" placeholder="Email Address" />
            </div>

            <div className="form-row">
              <input type="text" placeholder="Phone Number" />
              <input type="text" placeholder="Subject" />
            </div>

            <textarea placeholder="Write Message"></textarea>

            <button type="submit">Send Message</button>
          </form>

        </div>

      </div>

      {/* Full Width Map */}
      <div className="contact-map">
        <iframe
          src="https://www.google.com/maps?q=Zirakpur , Punjab , 140604&output=embed"
          title="map"
          loading="lazy"
        ></iframe>
      </div>

    </section>
  );
}

export default Contact;
